// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"7cda4b44","344":"3e08f875"}[chunkId] + ".chunk.css";
};